/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // console.log("custom.js!");
  // Add custom code below this line

  /**
   * Ensure background videos start from the beginning.
   */
  const observer = new MutationObserver(() => {
    const video = document.querySelector(".video-cover");
    if (!video) return;

    observer.disconnect();
    video.style.opacity = 0;

    video.addEventListener("loadedmetadata", () => {
      video.currentTime = 0;
      video.style.opacity = 1;
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  /**
   * Open media gallery linked videos in Photoswipe popup.
   * This is scoped to media gallery cards because that section
   * does not initialize the core videoPlay handler.
   */
  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".media-gallery__video-trigger[data-video-play]");
    if (!trigger) return;

    const videoHtml = trigger.getAttribute("data-video-play");
    if (!videoHtml || !videoHtml.trim()) return;

    event.preventDefault();

    if (window.theme && window.theme.a11y) {
      window.theme.a11y.state.trigger = trigger;
    }

    const items = [{ html: videoHtml }];
    const options = { mainClass: "pswp--video" };
    new window.theme.LoadPhotoswipe(items, options);
  });

  /**
   * When a product media thumbnail tied to a variant is selected,
   * sync the product form to that variant.
   */
  document.addEventListener("click", (event) => {
    const thumbnail = event.target.closest("[data-product-single-media-thumbs] [data-thumbnail-id]");
    if (!thumbnail) return;

    const productContainer = thumbnail.closest("[data-product]");
    if (!productContainer) return;

    const mediaId = thumbnail.getAttribute("data-id");
    if (!mediaId) return;

    const productJsonNode = productContainer.querySelector("[data-product-json]");
    if (!productJsonNode || !productJsonNode.textContent) return;

    let productData = null;
    try {
      productData = JSON.parse(productJsonNode.textContent);
    } catch (_error) {
      return;
    }

    const targetVariant = productData.variants?.find((variant) => {
      return String(variant?.featured_media?.id) === String(mediaId);
    });
    if (!targetVariant) return;

    const idInput = productContainer.querySelector('[data-product-form] [name="id"]');
    if (idInput && String(idInput.value) === String(targetVariant.id)) return;

    let eventTargetInput = null;

    targetVariant.options.forEach((optionValue, optionIndex) => {
      const optionKey = `option${optionIndex + 1}`;
      const optionInputs = Array.from(
        productContainer.querySelectorAll(`[data-single-option-selector][data-index="${optionKey}"]`),
      );
      if (!optionInputs.length) return;

      const matchingInput = optionInputs.find((input) => input.value === optionValue);
      const nextInput = matchingInput || optionInputs[0];
      if (!nextInput) return;

      if (nextInput.type === "radio" || nextInput.type === "checkbox") {
        nextInput.checked = true;
      } else {
        nextInput.value = optionValue;
      }

      if (!eventTargetInput) {
        eventTargetInput = nextInput;
      }
    });

    if (eventTargetInput) {
      eventTargetInput.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }

    if (idInput) {
      idInput.value = String(targetVariant.id);
      idInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
